import styled, { css } from 'styled-components'

import Avatar from '../Avatar'
import Icon from '../Icon'
import FormReview from '../../form/FormReview'

export const AddFeedbackModal = styled.div<{ $isVisible: boolean }>`
  padding: 3rem;
  border: 1px solid ${({ theme }) => theme.colors.greyContour};
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  display: none;
  z-index: 10;
  width: 100%;
  max-width: 825px;
  transform: translate(-50%, -50%);

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      display: block;
    `};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed ${({ theme }) => theme.colors.greyContour};
  padding-bottom: 2.8rem;
  margin-bottom: 3.7rem;
`

export const MemberAvatar = styled(Avatar)`
  flex-direction: row-reverse;
  > div {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
  }
`

export const CloseIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.greyContour};
  &:hover {
    cursor: pointer;
  }
`

export const StarPickerForm = styled(FormReview)``
